module.exports = __webpack_public_path__ + "assets/img/mc1.3f0337dc.png";